module.exports = __webpack_public_path__ + "static/media/recent-order.b1520f88.svg";